// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.searchInMiddle {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 2rem;
  gap: 2rem;
}
@media only screen and (max-width: 56.25em) {
  .searchInMiddle {
    flex-direction: column;
    align-items: center;
  }
  .searchInMiddle_filter {
    order: 2;
  }
  .searchInMiddle_search {
    order: 1;
  }
}

.modal {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 1001;
}
.modal__beside {
  display: flex;
  width: 38rem;
  justify-content: space-between;
}
.modal__beside__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
.modal__checks {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
.modal__checks_group {
  align-self: center;
}

.whiteTable {
  width: 100%;
  font-size: 1.4rem;
  overflow-y: auto;
  overflow-x: auto;
}
.whiteTable::-webkit-scrollbar:horizontal {
  width: 0;
  height: 0.7rem;
  background: var(--color-white);
}
.whiteTable::-webkit-scrollbar-thumb:horizontal {
  background: var(--color-grey);
  border-radius: 2rem;
}
.whiteTable::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 3rem 3rem 0;
}
.whiteTable::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 3rem;
}
.whiteTable table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.whiteTable table tr {
  padding: 0 1rem;
  align-items: center;
}
.whiteTable table th,
.whiteTable table td {
  padding: 1.2rem 2rem;
}
.whiteTable table th {
  font-weight: 700;
}
.whiteTable table thead tr {
  background-color: var(--color-dark);
  border-radius: 1rem;
  color: var(--color-white);
  position: sticky;
  top: 0;
  z-index: 50;
}
.whiteTable table tbody tr {
  background-color: var(--color-white);
}
.whiteTable table tbody tr:nth-child(even) {
  background-color: var(--color-table-grey);
}
.whiteTable table .action__text {
  font-weight: 600;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
}
.whiteTable table .action__icons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 2.4rem;
}
.whiteTable table .action__icons > * {
  cursor: pointer;
  position: relative;
}
.whiteTable table .action__icons > *:hover {
  color: var(--color-primary);
}
.whiteTable table .action__icons > * > :last-child {
  opacity: 0;
}
.whiteTable table .action__icons > * > :last-child:hover {
  opacity: 1;
}
.whiteTable table .action__icons > :not(last-child) {
  margin-right: 0.5rem;
}
.whiteTable table .action__details {
  font-size: 1rem;
  color: var(--color-white);
  padding: 0.8rem;
  background-color: rgba(0, 60, 151, 0.7);
  border-radius: 1rem;
  position: absolute;
  top: -0.7rem;
  left: -1.5rem;
}
.whiteTable table img {
  width: 5rem;
}

.sizeGuideTable {
  width: 100%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  font-size: 1.2rem;
  overflow-y: auto;
  overflow-x: auto;
}
.sizeGuideTable::-webkit-scrollbar:horizontal {
  width: 0;
  height: 0.7rem;
  background: var(--color-white);
}
.sizeGuideTable::-webkit-scrollbar-thumb:horizontal {
  background: var(--color-grey);
  border-radius: 2rem;
}
.sizeGuideTable::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 3rem 3rem 0;
}
.sizeGuideTable::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 3rem;
}
.sizeGuideTable table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.sizeGuideTable table tr {
  padding: 0 1rem;
  align-items: center;
}
.sizeGuideTable table th,
.sizeGuideTable table td {
  padding: 1.2rem 2rem;
  text-align: center;
}
.sizeGuideTable table th {
  font-weight: 700;
}
.sizeGuideTable table thead tr {
  background-color: var(--color-dark);
  border-radius: 1rem;
  color: var(--color-white);
  position: sticky;
  top: 0;
  z-index: 50;
}
.sizeGuideTable table tbody tr {
  background-color: var(--color-white);
}
.sizeGuideTable table tbody tr:nth-child(even) {
  background-color: var(--color-table-grey);
}

.tableStatus {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  width: 85%;
  font-size: 1rem;
  padding: 1.2rem 2rem;
}
.tableStatus__red {
  background-color: var(--color-error);
  color: var(--color-white);
}
.tableStatus__green {
  background-color: var(--color-green);
  color: var(--color-white);
}
.tableStatus__yellow {
  background-color: var(--color-yellow);
  color: var(--color-dark);
}
.tableStatus__dark {
  background-color: var(--color-dark);
  color: var(--color-white);
}

.filter_content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.filter_content > :not(last-child) {
  margin-right: 1rem;
}

.noInsights {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-error);
  font-size: var(--default-font-subtitle);
  text-align: center;
  height: 70%;
}

ul.custom-list li {
  display: flex;
  list-style-type: none;
  margin: 1rem;
  font-size: 14px;
  color: var(--color-dark);
}

ul.custom-list li:before {
  content: "✓";
  margin-right: 0.5em;
  font-weight: 700;
  color: var(--color-fash-primary-2);
}

.gridTable {
  width: 100%;
  margin-top: 3rem;
  font-size: 1.6rem;
}
.gridTable table {
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: center;
  width: 100%;
  max-width: 100%;
  border: none;
}
.gridTable tbody {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
  width: 100%;
}
@media only screen and (max-width: 75em) {
  .gridTable tbody {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media only screen and (max-width: 62.5em) {
  .gridTable tbody {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 43.75em) {
  .gridTable tbody {
    grid-template-columns: repeat(2, 1fr);
  }
}
.gridTable tr {
  display: grid;
  grid-template-columns: 100%;
  justify-items: center;
  gap: 1rem;
  background-color: var(--color-white);
  position: relative;
  padding: 0 0 2rem 0;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.gridTable td {
  width: 100%;
}
.gridTable td img {
  height: 34rem;
  width: 100%;
  object-fit: cover;
  top: 0;
  left: 0;
  margin: 0;
}
@media only screen and (max-width: 75em) {
  .gridTable td img {
    height: 43rem;
  }
}
@media only screen and (max-width: 62.5em) {
  .gridTable td img {
    height: 46rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .gridTable td img {
    height: 36rem;
  }
}

.PhoneInputInput {
  font-size: 1.8rem;
  font-family: inherit;
  color: var(--color-dark);
  padding-left: 2rem;
  height: 6rem;
  margin-top: 0.4rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid #999;
  display: block;
  box-sizing: border-box;
  outline: none;
}
.PhoneInputInput:focus, .PhoneInputInput:focus-visible, .PhoneInputInput:focus-within {
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
  box-shadow: inset 2px 2px 3px #cad2e1;
}

.masonryLayout {
  width: 100%;
  margin-top: 3rem;
  font-size: 1.6rem;
}
.masonryLayout__container {
  box-sizing: border-box;
  text-align: center;
  width: 100%;
  max-width: 100%;
  border: none;
}
.masonryLayout__body {
  width: 100%;
}
.masonryLayout__cell {
  display: grid;
  grid-template-columns: 100%;
  justify-items: center;
  gap: 1rem;
  background-color: var(--color-white);
  position: relative;
  padding: 0 0 2rem 0;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.masonryLayout__item {
  width: 100%;
}
.masonryLayout__item img {
  width: 100%;
  object-fit: contain;
  top: 0;
  left: 0;
  margin: 0;
  border-radius: 3rem;
}

.track {
  height: 5px;
  background: var(--color-dark);
}
.track-0, .track-2 {
  background: #ddd;
}

.sanitized__content h1,
.sanitized__content h2,
.sanitized__content h3,
.sanitized__content h4,
.sanitized__content h5,
.sanitized__content h6 {
  font-weight: 700;
}
.sanitized__content h1 {
  font-size: 4.8rem;
}
.sanitized__content h2 {
  font-size: 3.6rem;
}
.sanitized__content h3 {
  font-size: 3.2rem;
}
.sanitized__content h4 {
  font-size: 2.4rem;
}
.sanitized__content h5 {
  font-size: 2rem;
}
.sanitized__content h6 {
  font-size: 1.6rem;
}
.sanitized__content ul,
.sanitized__content ol {
  margin-left: 2rem;
  margin-bottom: 1rem;
}
.sanitized__content li {
  margin-bottom: 0.5rem;
}
.sanitized__content strong {
  font-weight: bold;
}
.sanitized__content em {
  font-style: italic;
}
.sanitized__content u {
  text-decoration: underline;
}

.sectionEditBtn {
  background-color: var(--color-primary);
  padding: 1rem 2rem;
  border-radius: 8px;
  display: flex;
  gap: 1rem;
  align-items: center;
  color: var(--color-white);
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 799;
}
.sectionEditBtn:hover {
  background-color: var(--color-primary-4);
}

.center_container {
  display: flex;
  justify-content: center;
}

.fullWidth__border {
  border-bottom: 1px solid var(--color-grey-3);
}

.sanitized__content > * {
  white-space: wrap;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Global/GlobalStyles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACC,aAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AAAD;AAEC;EAPD;IAQE,sBAAA;IACA,mBAAA;EACA;EACA;IACC,QAAA;EACD;EAEA;IACC,QAAA;EAAD;AACF;;AAIA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AADD;AAGC;EACC,aAAA;EACA,YAAA;EACA,8BAAA;AADF;AAGE;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AADH;AAKC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AAHF;AAKE;EACC,kBAAA;AAHH;;AAQA;EACC,WAAA;EAGA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAPD;AASC;EACC,QAAA;EACA,cAAA;EACA,8BAAA;AAPF;AAUC;EACC,6BAAA;EACA,mBAAA;AARF;AAWC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AATF;AAYC;EACC,mCAAA;EACA,mBAAA;AAVF;AAaC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAXF;AAcE;EACC,eAAA;EACA,mBAAA;AAZH;AAeE;;EAEC,oBAAA;AAbH;AAgBE;EACC,gBAAA;AAdH;AAmBG;EACC,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAjBJ;AAsBG;EACC,oCAAA;AApBJ;AAsBI;EACC,yCAAA;AApBL;AA0BG;EACC,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;AAxBJ;AA2BG;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AAzBJ;AA2BI;EACC,eAAA;EACA,kBAAA;AAzBL;AA2BK;EACC,2BAAA;AAzBN;AA4BK;EACC,UAAA;AA1BN;AA4BM;EACC,UAAA;AA1BP;AA+BI;EACC,oBAAA;AA7BL;AAiCG;EACC,eAAA;EACA,yBAAA;EACA,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AA/BJ;AAmCE;EACC,WAAA;AAjCH;;AAsCA;EACC,WAAA;EAEA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AApCD;AAsCC;EACC,QAAA;EACA,cAAA;EACA,8BAAA;AApCF;AAuCC;EACC,6BAAA;EACA,mBAAA;AArCF;AAwCC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AAtCF;AAyCC;EACC,mCAAA;EACA,mBAAA;AAvCF;AA0CC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAxCF;AA2CE;EACC,eAAA;EACA,mBAAA;AAzCH;AA4CE;;EAEC,oBAAA;EACA,kBAAA;AA1CH;AA6CE;EACC,gBAAA;AA3CH;AAgDG;EACC,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AA9CJ;AAmDG;EACC,oCAAA;AAjDJ;AAmDI;EACC,yCAAA;AAjDL;;AAwDA;EACC,aAAA;EAEA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;AAtDD;AAwDC;EACC,oCAAA;EACA,yBAAA;AAtDF;AAyDC;EACC,oCAAA;EACA,yBAAA;AAvDF;AA0DC;EACC,qCAAA;EACA,wBAAA;AAxDF;AA2DC;EACC,mCAAA;EACA,yBAAA;AAzDF;;AA8DC;EACC,aAAA;EACA,eAAA;EACA,mBAAA;AA3DF;AA6DE;EACC,kBAAA;AA3DH;;AAgEA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;AA7DD;;AAgEA;EACC,aAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AA7DD;;AAgEA;EACC,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kCAAA;AA7DD;;AAgEA;EACC,WAAA;EACA,gBAAA;EACA,iBAAA;AA7DD;AA+DC;EACC,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AA7DF;AAgEC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;AA9DF;AAgEE;EAND;IAOE,qCAAA;EA7DD;AACF;AA+DE;EAVD;IAWE,qCAAA;EA5DD;AACF;AA8DE;EAdD;IAeE,qCAAA;EA3DD;AACF;AA8DC;EACC,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;AA5DF;AA+DC;EAKC,WAAA;AAjEF;AAmEE;EACC,aAAA;EACA,WAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;AAjEH;AAmEG;EARD;IASE,aAAA;EAhEF;AACF;AAkEG;EAZD;IAaE,aAAA;EA/DF;AACF;AAiEG;EAhBD;IAiBE,aAAA;EA9DF;AACF;;AAmEA;EACC,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;AAhED;AAkEC;EAGC,2BAAA;EACA,sCAAA;EACA,qCAAA;AAlEF;;AAsEA;EACC,WAAA;EACA,gBAAA;EACA,iBAAA;AAnED;AAqEC;EACC,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAnEF;AAsEC;EACC,WAAA;AApEF;AAuEC;EACC,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;AArEF;AAwEC;EACC,WAAA;AAtEF;AAwEE;EACC,WAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,mBAAA;AAtEH;;AA6EA;EACC,WAAA;EACA,6BAAA;AA1ED;AA4EC;EAEC,gBAAA;AA3EF;;AAiFE;;;;;;EAMC,gBAAA;AA9EH;AAiFE;EACC,iBAAA;AA/EH;AAkFE;EACC,iBAAA;AAhFH;AAmFE;EACC,iBAAA;AAjFH;AAoFE;EACC,iBAAA;AAlFH;AAqFE;EACC,eAAA;AAnFH;AAsFE;EACC,iBAAA;AApFH;AAuFE;;EAEC,iBAAA;EACA,mBAAA;AArFH;AAwFE;EACC,qBAAA;AAtFH;AAyFE;EACC,iBAAA;AAvFH;AA0FE;EACC,kBAAA;AAxFH;AA2FE;EACC,0BAAA;AAzFH;;AA8FA;EACC,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AA3FD;AA6FC;EACC,wCAAA;AA3FF;;AA+FA;EACC,aAAA;EACA,uBAAA;AA5FD;;AAgGC;EACC,4CAAA;AA7FF;;AAkGC;EACC,iBAAA;AA/FF","sourcesContent":["@import '../variables/breakpoints';\n\n.searchInMiddle {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\tmargin-top: 2rem;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t&_filter {\n\t\t\torder: 2;\n\t\t}\n\n\t\t&_search {\n\t\t\torder: 1;\n\t\t}\n\t}\n}\n\n.modal {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tz-index: 1001;\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\twidth: 38rem;\n\t\tjustify-content: space-between;\n\n\t\t&__grid {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\tgap: 2rem;\n\t\t}\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\n\t\t&_group {\n\t\t\talign-self: center;\n\t\t}\n\t}\n}\n\n.whiteTable {\n\twidth: 100%;\n\t// max-height: 100vh;\n\t// margin-top: 3rem;\n\tfont-size: 1.4rem;\n\toverflow-y: auto;\n\toverflow-x: auto;\n\n\t&::-webkit-scrollbar:horizontal {\n\t\twidth: 0;\n\t\theight: 0.7rem;\n\t\tbackground: var(--color-white);\n\t}\n\n\t&::-webkit-scrollbar-thumb:horizontal {\n\t\tbackground: var(--color-grey);\n\t\tborder-radius: 2rem;\n\t}\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 3rem 3rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 3rem;\n\t}\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\t// margin-top: 2rem;\n\n\t\ttr {\n\t\t\tpadding: 0 1rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 1.2rem 2rem;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tthead {\n\t\t\t// margin-bottom: 2rem;\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tposition: sticky;\n\t\t\t\ttop: 0;\n\t\t\t\tz-index: 50;\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-table-grey);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.action {\n\t\t\t&__text {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\ttext-decoration: underline;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t&__icons {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tfont-size: 2.4rem;\n\n\t\t\t\t& > * {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\t}\n\n\t\t\t\t\t& > :last-child {\n\t\t\t\t\t\topacity: 0;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t& > :not(last-child) {\n\t\t\t\t\tmargin-right: 0.5rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__details {\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tpadding: 0.8rem;\n\t\t\t\tbackground-color: rgba(#003c97, 0.7);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -0.7rem;\n\t\t\t\tleft: -1.5rem;\n\t\t\t}\n\t\t}\n\n\t\timg {\n\t\t\twidth: 5rem;\n\t\t}\n\t}\n}\n\n.sizeGuideTable {\n\twidth: 100%;\n\t// max-height: 100vh;\n\tmargin-top: 3rem;\n\tmargin-bottom: 3rem;\n\tfont-size: 1.2rem;\n\toverflow-y: auto;\n\toverflow-x: auto;\n\n\t&::-webkit-scrollbar:horizontal {\n\t\twidth: 0;\n\t\theight: 0.7rem;\n\t\tbackground: var(--color-white);\n\t}\n\n\t&::-webkit-scrollbar-thumb:horizontal {\n\t\tbackground: var(--color-grey);\n\t\tborder-radius: 2rem;\n\t}\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 3rem 3rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 3rem;\n\t}\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\t// margin-top: 2rem;\n\n\t\ttr {\n\t\t\tpadding: 0 1rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 1.2rem 2rem;\n\t\t\ttext-align: center;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tthead {\n\t\t\t// margin-bottom: 2rem;\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tposition: sticky;\n\t\t\t\ttop: 0;\n\t\t\t\tz-index: 50;\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-table-grey);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.tableStatus {\n\tdisplay: flex;\n\t// font-weight: 700;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 1rem;\n\twidth: 85%;\n\tfont-size: 1rem;\n\tpadding: 1.2rem 2rem;\n\n\t&__red {\n\t\tbackground-color: var(--color-error);\n\t\tcolor: var(--color-white);\n\t}\n\n\t&__green {\n\t\tbackground-color: var(--color-green);\n\t\tcolor: var(--color-white);\n\t}\n\n\t&__yellow {\n\t\tbackground-color: var(--color-yellow);\n\t\tcolor: var(--color-dark);\n\t}\n\n\t&__dark {\n\t\tbackground-color: var(--color-dark);\n\t\tcolor: var(--color-white);\n\t}\n}\n\n.filter {\n\t&_content {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\n\t\t& > :not(last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n}\n\n.noInsights {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--color-error);\n\tfont-size: var(--default-font-subtitle);\n\ttext-align: center;\n\theight: 70%;\n}\n\nul.custom-list li {\n\tdisplay: flex;\n\tlist-style-type: none;\n\tmargin: 1rem;\n\tfont-size: 14px;\n\tcolor: var(--color-dark);\n}\n\nul.custom-list li:before {\n\tcontent: '✓';\n\tmargin-right: 0.5em;\n\tfont-weight: 700;\n\tcolor: var(--color-fash-primary-2);\n}\n\n.gridTable {\n\twidth: 100%;\n\tmargin-top: 3rem;\n\tfont-size: 1.6rem;\n\n\ttable {\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t}\n\n\ttbody {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(6, 1fr);\n\t\tgap: 1rem;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-1200) {\n\t\t\tgrid-template-columns: repeat(4, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\t}\n\n\ttr {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t\tjustify-items: center;\n\t\tgap: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tposition: relative;\n\t\tpadding: 0 0 2rem 0;\n\t\tcursor: pointer;\n\t\ttransition: transform 0.3s ease;\n\t}\n\n\ttd {\n\t\t// &>* {\n\t\t// \tmargin: 0 2rem;\n\t\t// }\n\n\t\twidth: 100%;\n\n\t\timg {\n\t\t\theight: 34rem;\n\t\t\twidth: 100%;\n\t\t\tobject-fit: cover;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tmargin: 0;\n\n\t\t\t@media only screen and (max-width: $bp-1200) {\n\t\t\t\theight: 43rem;\n\t\t\t}\n\n\t\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\t\theight: 46rem;\n\t\t\t}\n\n\t\t\t@media only screen and (max-width: $bp-500) {\n\t\t\t\theight: 36rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.PhoneInputInput {\n\tfont-size: 1.8rem;\n\tfont-family: inherit;\n\tcolor: var(--color-dark);\n\tpadding-left: 2rem;\n\theight: 6rem;\n\tmargin-top: 0.4rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-white);\n\tborder: 1px solid #999;\n\tdisplay: block;\n\tbox-sizing: border-box;\n\toutline: none;\n\n\t&:focus,\n\t&:focus-visible,\n\t&:focus-within {\n\t\tcolor: var(--color-primary);\n\t\tborder: 2px solid var(--color-primary);\n\t\tbox-shadow: inset 2px 2px 3px #cad2e1;\n\t}\n}\n\n.masonryLayout {\n\twidth: 100%;\n\tmargin-top: 3rem;\n\tfont-size: 1.6rem;\n\n\t&__container {\n\t\tbox-sizing: border-box;\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t}\n\n\t&__body {\n\t\twidth: 100%;\n\t}\n\n\t&__cell {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t\tjustify-items: center;\n\t\tgap: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tposition: relative;\n\t\tpadding: 0 0 2rem 0;\n\t\tcursor: pointer;\n\t\ttransition: transform 0.3s ease;\n\t}\n\n\t&__item {\n\t\twidth: 100%;\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\tobject-fit: contain;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tmargin: 0;\n\t\t\tborder-radius: 3rem;\n\t\t}\n\t}\n}\n\n//Slider\n\n.track {\n\theight: 5px;\n\tbackground: var(--color-dark);\n\n\t&-0,\n\t&-2 {\n\t\tbackground: #ddd;\n\t}\n}\n\n.sanitized {\n\t&__content {\n\t\th1,\n\t\th2,\n\t\th3,\n\t\th4,\n\t\th5,\n\t\th6 {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\th1 {\n\t\t\tfont-size: 4.8rem;\n\t\t}\n\n\t\th2 {\n\t\t\tfont-size: 3.6rem;\n\t\t}\n\n\t\th3 {\n\t\t\tfont-size: 3.2rem;\n\t\t}\n\n\t\th4 {\n\t\t\tfont-size: 2.4rem;\n\t\t}\n\n\t\th5 {\n\t\t\tfont-size: 2rem;\n\t\t}\n\n\t\th6 {\n\t\t\tfont-size: 1.6rem;\n\t\t}\n\n\t\tul,\n\t\tol {\n\t\t\tmargin-left: 2rem;\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\tli {\n\t\t\tmargin-bottom: 0.5rem;\n\t\t}\n\n\t\tstrong {\n\t\t\tfont-weight: bold;\n\t\t}\n\n\t\tem {\n\t\t\tfont-style: italic;\n\t\t}\n\n\t\tu {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n}\n\n.sectionEditBtn {\n\tbackground-color: var(--color-primary);\n\tpadding: 1rem 2rem;\n\tborder-radius: 8px;\n\tdisplay: flex;\n\tgap: 1rem;\n\talign-items: center;\n\tcolor: var(--color-white);\n\tposition: absolute;\n\ttop: 2rem;\n\tright: 2rem;\n\tz-index: 799;\n\n\t&:hover {\n\t\tbackground-color: var(--color-primary-4);\n\t}\n}\n\n.center_container {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.fullWidth {\n\t&__border {\n\t\tborder-bottom: 1px solid var(--color-grey-3);\n\t}\n}\n\n.sanitized__content {\n\t& > * {\n\t\twhite-space: wrap;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
